// eslint-disable-next-line no-unused-vars
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { config, url } from '@/store/index'
import { debounce } from '@/utils/utils'
import { CONTRACT_URL } from '@/api/contracts'
// import { toggleItem } from '@/utils/table/table'

const state = () => ({
  tableHeaders: [
    // {
    //   title: '№',
    //   isSortable: true
    // },
    {
      title: 'Контрагент',
      isSortable: true,
      sortName: 'partner.long_name',
      dispatchName: 'contractListPage/getContractsSort'
    },
    {
      title: 'Проект',
      isSortable: true,
      sortName: 'treaty_project.name',
      dispatchName: 'contractListPage/getContractsSort'
    },
    {
      title: 'Номер договора',
      isSortable: true,
      sortName: 'treaty_number',
      dispatchName: 'contractListPage/getContractsSort'
    },
    {
      title: 'Тип договора',
      isSortable: true,
      sortName: 'treaty_type.name',
      dispatchName: 'contractListPage/getContractsSort'
    },
    {
      title: 'Дата начала',
      isSortable: true,
      sortName: 'start_date',
      dispatchName: 'contractListPage/getContractsSort'
    },
    {
      title: 'Дата окончания',
      isSortable: false
    },
    {
      title: 'Сумма',
      isSortable: true,
      sortName: 'amount',
      dispatchName: 'contractListPage/getContractsSort'
    },
    {
      title: 'Статус',
      isSortable: true,
      sortName: 'treaty_status.name',
      dispatchName: 'contractListPage/getContractsSort'
    },
    {
      title: 'Стадия',
      isSortable: true,
      sortName: 'treaty_stage.name',
      dispatchName: 'contractListPage/getContractsSort'
    },
    {
      title: 'Отвественный',
      isSortable: true,
      sortName: 'users.surname',
      dispatchName: 'contractListPage/getContractsSort'
    }
  ],
  contracts: [],
  modal: {
    active: false,
    updatedId: null,
    name: '',
    validation: {
      name: { id: null, message: '' }
    }
  },
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  searchValue: '',
  filter: {},
  sort: {},
  isLoading: true,
  responseModal: {
    isActive: false,
    title: '',
    text: '',
    type: ''
  },
  isActiveDelete: false,
  debounce: null,
  filterIsActive: false
})

const getters = {
  getContractsList: state => state.contracts,
  getContractsListTableHeaders: state => state.tableHeaders,
  getContractsListModal: state => state.modal,
  getContractsListSearchValue: state => state.searchValue,
  getContractsListFilter: state => state.filter,
  getContractsListPagination: state => state.pagination,
  getContractListIsLoading: state => state.isLoading,
  getContractsListResponseModal: state => state.responseModal,
  getContractsListActiveDelete: state => state.isActiveDelete,
  getFilterIsActive: state => state.filterIsActive
}

const mutations = {
  SET_DEBOUNCE: (state, debounce) => {
    state.debounce = debounce
  },
  GET_CONTRACTS: (state, contracts) => {
    state.contracts = contracts.map(contract => {
      return {
        ...contract,
        project: contract.project && contract.project_id ? contract.project : { id: null, name: '' },
        stage: contract.stage && contract.stage_id ? contract.stage : { id: null, name: '' },
        status: contract.status && contract.status_id ? contract.status : { id: null, name: '' },
        type: contract.type && contract.type_id ? contract.type : { id: null, name: '' },
        partner: contract.partner && contract.partner_id ? contract.partner : { id: null, name: '' },

        isControlsActive: false,
        isActive: false
      }
    })
    state.isLoading = false
  },
  TOGGLE_CONTRACTS_LIST_ITEM_CONTROLS: (state, itemId) => {
    state.contracts.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  SHOW_CONTRACTS_LIST_MODAL: (state, itemId) => {
    state.modal.active = true
    if (itemId) {
      const selectedContract = state.contracts.filter(contract => {
        return contract.id === itemId
      }).pop()

      state.modal.updatedId = itemId
      state.modal.number = selectedContract.number
      state.modal.name = selectedContract.name
      state.modal.project = selectedContract.project
      state.modal.numberContract = selectedContract.numberContract
      state.modal.typeContract = selectedContract.typeContract
      state.modal.dateStart = selectedContract.dateStart
      state.modal.dateEnd = selectedContract.dateEnd
      state.modal.sum = selectedContract.sum
      state.modal.status = selectedContract.status
      state.modal.stage = selectedContract.stage
      state.modal.responsible = selectedContract.responsible
    }
  },
  SET_CONTRACTS_ITEM_NAME: (state, value) => {
    state.modal.name = value
  },
  SET_CONTRACTS_ITEM_COLOR: (state, value) => {
    state.modal.color = value
  },
  SET_CONTRACTS_ITEM_FULL_NAME: (state, value) => {
    state.modal.fullName = value
  },
  CLEAR_CONTRACTS_MODAL_VALIDATION: (state, inputName) => {
    switch (inputName) {
      case 'name':
        state.modal.validation.name = { id: null, message: '' }
        break
      default:
        break
    }
  },
  CLOSE_CONTRACTS_LIST_MODAL: (state) => {
    state.modal.active = false
    state.modal.updatedId = null
    state.modal.name = ''
    state.modal.validation.name = { id: null, message: '' }
  },

  // pagination
  SET_CONTRACTS_LIST_PAGINATION: (state, headers) => {
    state.pagination.currentPage = Number(headers['x-pagination-current-page'])
    state.pagination.lastPage = Number(headers['x-pagination-page-count'])
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(Number(headers['x-pagination-page-count'])).keys()].map(i => ++i)
  },
  RESET_CONTRACTS_LIST_CURRENT_PAGE: (state) => {
    state.pagination.currentPage = 1
  },
  SET_CURRENT_PAGE: (state, pageNum) => {
    state.pagination.currentPage = pageNum
  },

  // search
  SET_CONTRACTS_LIST_SEARCH_VALUE: (state, searchValue) => {
    state.searchValue = searchValue
  },

  // sort
  SET_CONTRACTS_LIST_SORT: (state, sortOptions) => {
    state.sort = sortOptions
  },

  // filter
  SET_CONTRACTS_LIST_FILTER: (state, filter) => {
    state.filter = filter
  },

  SET_CONTRACTS_LIST_FILTER_ACTIVE: (state, isActive) => {
    state.filterIsActive = isActive
  },

  // delete checked items
  DELETE_CONTRACTS_LIST_CHECKED_ITEMS_SUCCESS: (state) => {
    state.responseModal.isActive = true
    state.responseModal.title = 'Успех!'
    state.responseModal.text = 'Вы успешно удалили договор(а)'
    state.responseModal.type = 'main'
  },
  DELETE_CONTRACTS_LIST_CHECKED_ITEMS_ERROR: (state, errorItems) => {
    let listNamesErrorItems
    errorItems.forEach(e => {
      listNamesErrorItems = listNamesErrorItems + ` ${e.short_name}`
    })
    state.responseModal.isActive = true
    state.responseModal.title = 'Ошибка!'
    state.responseModal.text = `При удалении договора произошла ошибка:${listNamesErrorItems}`
    state.responseModal.type = 'main'
  },
  CLOSE_DELETE_CONTRACTS_LIST_MODAL: (state) => {
    state.responseModal.isActive = false
    state.responseModal.title = ''
    state.responseModal.text = ''
    state.responseModal.type = ''
  },
  TOGGLE_CONTRACTS_LIST_ITEM_ACTIVE: (state, itemId) => {
    // const counter = toggleItem(itemId, state.contracts)
    const itemsLength = state.contracts.length
    let counter = 0

    state.contracts.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isActive = !elem.isActive
      }
      if (elem.isActive) {
        counter += 1
      }
    })

    counter > 0 ? state.isActiveDelete = true : state.isActiveDelete = false

    state.tableHeaders.allActive = counter === itemsLength
  },
  TOGGLE_CONTRACTS_LIST_ITEM_ACTIVE_ALL: (state) => {
    state.tableHeaders.allActive = !state.tableHeaders.allActive
    state.tableHeaders.allActive ? state.isActiveDelete = true : state.isActiveDelete = false

    state.contracts.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  RESET_CONTRACTS_LIST_ALL_CHECKS: (state) => {
    state.tableHeaders.allActive = false
    state.isActiveDelete = false
    state.contracts.forEach((elem) => {
      elem.isActive = state.tableHeaders.allActive
    })
  },
  SET_LOADING: (state, loading) => {
    state.isLoading = loading
  },

  // reset store
  RESET_CONTRACTS_LIST_STORE: (state) => {
    // state.searchValue = ''
    state.sort = {}
    // state.filter = {}
    state.isActiveDelete = false
    state.tableHeaders.allActive = false
    state.pagination.currentPage = 1
  }
}

const actions = {
  getContracts ({ commit, state }) {
    const params = {
      expand: 'project,status,stage,type,partner,worker',
      sort: (state.sort.descending ? '-' : '') + (state.sort.name || 'id'),
      take: state.pagination.currentTake,
      page: state.pagination.currentPage,
      'search[all]': state.searchValue || null
    }

    const filter = {
      ProjectId: state.filter.project?.id,
      StageId: state.filter.stage?.id,
      StartDate: state.filter.startDate,
      StatusId: state.filter.status?.id,
      TreatyNumber: state.filter.contractNumber,
      TypeId: state.filter.type?.id,
      Amount: state.filter.sum,
      FinishDate: state.filter.endDate,
      PartnerId: state.filter.contractor?.id,
      WorkerId: state.filter.assignee?.id
    }

    for (const key in filter) {
      if (filter[key]) {
        params[`search[${key}]`] = filter[key]
      }
    }

    commit('SET_LOADING', true)
    axios.get(`${url}/${CONTRACT_URL}`, { params, ...config }).then(response => {
      commit('GET_CONTRACTS', response.data.data)
      commit('SET_CONTRACTS_LIST_PAGINATION', response.headers)
    }).catch(error => {
      console.log('ошибка получения списка документы', error)
    })
  },
  toggleContractsListItemControls ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTS_LIST_ITEM_CONTROLS', itemId)
  },
  closeContractsListItemControls ({ commit }, itemId) {
    commit('CLOSE_CONTRACTS_LIST_ITEM_CONTROLS', itemId)
  },
  toggleContractsListItemActive ({ commit }, itemId) {
    commit('TOGGLE_CONTRACTS_LIST_ITEM_ACTIVE', itemId)
  },
  toggleContractsListItemActiveAll ({ commit }) {
    commit('TOGGLE_CONTRACTS_LIST_ITEM_ACTIVE_ALL')
  },

  deleteContract ({ dispatch }, itemId) {
    axios.delete(`${url}/${CONTRACT_URL}/${itemId}`, config).then(response => {
      dispatch('getContracts')
    }).catch(error => {
      console.log('Ошибка удаления пользователя:' + error)
    })
  },
  setContractsItemName ({ commit }, value) {
    commit('SET_CONTRACTS_ITEM_NAME', value)
  },
  setContractsItemColor ({ commit }, value) {
    commit('SET_CONTRACTS_ITEM_COLOR', value)
  },

  closeContractsModal ({ commit }) {
    commit('CLOSE_CONTRACTS_LIST_MODAL')
  },
  removeContracts ({ commit }, itemId) {
    // DELETE request
  },

  // pagination
  getContractsListPage ({ commit, dispatch }, pageNum) {
    commit('SET_CURRENT_PAGE', pageNum)
    dispatch('getContracts')
  },
  resetContractsListCurrentPage ({ commit }) {
    commit('RESET_CONTRACTS_LIST_CURRENT_PAGE')
  },

  // search
  setContractsListSearchValue ({ state, commit, dispatch }, searchValue) {
    commit('SET_CONTRACTS_LIST_SEARCH_VALUE', searchValue)

    if (!state.debounce) {
      commit('SET_DEBOUNCE', debounce(function () {
        commit('RESET_CONTRACTS_LIST_CURRENT_PAGE')
        dispatch('getContracts')

        commit('SET_DEBOUNCE', null)
      }, 500))

      state.debounce()
    }
  },

  // sort
  getContractsSort ({ commit, dispatch }, sort) {
    console.log('sort', sort)
    commit('SET_CONTRACTS_LIST_SORT', sort)
    dispatch('getContracts')
  },

  // delete checked items
  deleteContractsListCheckedItems ({ commit, state, dispatch }) {
    const checkedItems = []
    const errorItems = []
    state.contracts.forEach((e) => {
      if (e.isActive) {
        checkedItems.push(e)
      }
    })

    async function processMessages (array) {
      for (const item of array) {
        await axios.delete(`${url}/${CONTRACT_URL}/${item.id}`, config).then((response) => {
        }).catch(error => {
          errorItems.push(item)
          console.log('Ошибка удаления контрагента', error)
        })
      }
    }
    processMessages(checkedItems).then(() => {
      if (errorItems.length > 0) {
        commit('RESET_CONTRACTS_LIST_ALL_CHECKS')
        commit('DELETE_CONTRACTS_LIST_CHECKED_ITEMS_ERROR', errorItems)
        dispatch('getContracts')
      } else {
        commit('RESET_CONTRACTS_LIST_ALL_CHECKS')
        commit('DELETE_CONTRACTS_LIST_CHECKED_ITEMS_SUCCESS')
        dispatch('getContracts')
      }
    })
  },
  closeContractsListDeleteModal ({ commit }) {
    commit('CLOSE_DELETE_CONTRACTS_LIST_MODAL')
  },
  exportContractsListExcel () {
    axios.get(`${url}/${CONTRACT_URL}/export/excel`, config).then(response => {
      const link = document.createElement('a')
      link.href = response.data.data
      link.click()
      link.remove()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
